import loadable from '@loadable/component';

import { readPersonalizationSettings } from '../user/storage/personalization';
import landingPageQuery from './query.graphql';

const LandingPage = loadable(() =>
  import(/* webpackChunkName: "landing-page" */ './landing-page')
);

LandingPage.graphQL = landingPageQuery;

LandingPage.loadOrder = [
  {
    rootCategories: true,
    campaignDeals: true,
    forumTopics: true,
    shopOfTheYear: true,
  },
  {
    recommendations: true,
    newProductRecommendations: true,
  },
];

LandingPage.variables = () => ({
  personalizationExcludeCategories: readPersonalizationSettings().notInterestedIn.categories.map(
    category => +category.id
  ),
});

export default LandingPage;
